import React, { useState } from "react";
import { Container, Row, Col } from "shards-react";
import PageTitle from "./../components/common/PageTitle";
import { useAuth } from '../contexts/AuthContext';
import useGetUsers from "../hooks/useGetUsers"
import UserSelectionCard from "../components/components-overview/UserSelectionCard";
import PastReportsTable from "../components/components-overview/PastReportsTable";
import updateInvoices from "../hooks/updateInvoices";
import UpdateReportsCard from "../components/components-overview/UpdateReportsCard"
import AddPastReportCard from "../components/components-overview/AddPastReportCard";
import deletePastReport from "../hooks/deletePastReport";
import SkeletonArticle from "../components/skeleton/SkeletonArticle";
import isUserAdmin from "../utils/isUserAdmin";
import { ToastContainer, Slide } from "react-toastify";

const AdminReportsOverview = () => {
  const { currentUser } = useAuth();
  const { docs } = useGetUsers("users");

  const [selectedUser, setSelectedUser] = useState('');

  const handleUserSelection = (user) => {
    const selectedUser = docs.filter(doc => doc.id === user)
    setSelectedUser(selectedUser[0])
  }
  const handleDeleteInvoice = (invoice_id) => {
    if (isUserAdmin(currentUser)) {
      const newInvoices = selectedUser.invoices.filter(invoice => {
        return invoice.invoice_id !== invoice_id
      })
      updateInvoices(selectedUser.id, newInvoices)
    }
  }

  const handleDeleteReport = (url, reportId) => {
    if(isUserAdmin(currentUser)){
      deletePastReport(url, reportId)
    }
  }
  return (
    <>
          {/* Success Toast when user successfully deleted */}
      <ToastContainer
        position="top-center"
        newestOnTop={true}
        closeOnClick
        rtl={false}
        transition={Slide}
        pauseOnHover={false}
      />
      <Container fluid className="px-4">
        <Row noGutters className="page-header py-4">
          <PageTitle title="Reports Overview" subtitle={currentUser.username ? currentUser.username : 'Your Company'} className="text-sm-left mb-3" />
        </Row>
        <Row>
          <Col md="4" className="">
            {!docs.length > 0 && <SkeletonArticle />}
            {docs.length > 0 && <UserSelectionCard docs={docs} handleUserSelection={handleUserSelection} selectedUser={selectedUser} />}
          </Col>
          {/* <Col md="4">
            <UserReportsTable docs={docs} handleDeleteInvoice={handleDeleteInvoice} selectedUser={selectedUser} />
          </Col> */}
          <Col md="8">
            <UpdateReportsCard docs={docs} selectedUser={selectedUser} />
          </Col>
        </Row>
        <Row>
          <Col md="6">
            <PastReportsTable docs={docs} selectedUser={selectedUser} handleDeleteReport={handleDeleteReport} />
          </Col>
          <Col md="6">
            <AddPastReportCard docs={docs} selectedUser={selectedUser} />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default AdminReportsOverview;